import { useMutation } from "@tanstack/react-query";
import { checkAuthAccounts } from "~/lib/server-functions/check-auth-accounts";

type Payload = {
  email: string;
};

export const useCheckAuthAccounts = () => {
  return useMutation({
    mutationFn: async (payload: Payload) => {
      return await checkAuthAccounts({ data: payload });
    },
  });
};
